<script setup lang="ts">
import {
  ErrorSnackbar,
  useUserStore,
  type ServiceStore as BasicsServiceStore,
} from '@blueprint/frontend-basics'
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'

import type { useServiceStore } from './stores/service.store'

const { t } = useI18n()
const userStore = useUserStore()
const serviceStore = inject<ReturnType<typeof useServiceStore>>('serviceStore')

const startLogin = (): void => {
  void serviceStore?.authService.startLoginProcess(window.location.href)
}
</script>

<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title>{{ t('general.appName') }}</v-toolbar-title>
      <v-spacer />
      <v-progress-circular
        v-if="userStore.isLoading"
        color="primary"
        indeterminate
      />
      <v-btn
        v-else-if="userStore.isAnonymous && serviceStore"
        @click="startLogin"
      >
        {{ t('general.login') }}
      </v-btn>
      <v-btn
        v-else-if="serviceStore"
        @click="serviceStore.authService.logout()"
      >
        {{ t('general.logout') }}
      </v-btn>
    </v-app-bar>

    <v-main>
      <RouterView />
    </v-main>

    <ErrorSnackbar />
  </v-app>
</template>
